import { useTranslator } from "@sunrise/translator";
import { usePlayerPlayingInfo } from "@sunrise/yallo-player-controls";
import clsx from "clsx";
import { type ReactElement } from "react";

import { ChannelLogo } from "@/components/channel-logo/channel-logo";
import * as styles from "@/features/player-controls/player-controls.css";
import { typography } from "@/styles/typography.css";

export function PlayerControlsPlayingInfo(): ReactElement {
  const t = useTranslator();
  const { title, channelLogo, status, schedule, subtitle } =
    usePlayerPlayingInfo(t);

  return (
    <div className={styles.informationContainer}>
      {title && (
        <h1
          data-testid="title"
          className={clsx(styles.title, typography.h1.bold)}
        >
          {title}
        </h1>
      )}
      {(!!schedule || !!subtitle) && (
        <div className={styles.subtitleContainer}>
          {channelLogo ? (
            <ChannelLogo
              className={styles.channelLogo}
              url={channelLogo.url}
              data-testid="channel-logo"
            />
          ) : null}

          <h2
            data-testid="subtitle"
            className={clsx(styles.subtitle, typography.h6.bold)}
          >
            {schedule
              ? [status, schedule].filter(Boolean).join(", ")
              : subtitle}
          </h2>
        </div>
      )}
    </div>
  );
}
